import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorsModule } from './errors/errors.module';
import { PublicModule } from './public/public.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { GuardsModule } from './guards/guards.module';
import { ServicesModule } from './services/services.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AuthInterceptor } from './security/auth-interceptor';
import { PatentSearchGuard } from './guards/patent-search.guard';
import { ConfigService } from './services/config.service';
import { ConfirmModalService } from './services/confirm-modal.service';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ErrorsModule,
    PublicModule,
    GuardsModule,
    ServicesModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    ButtonModule,
    ConfirmDialogModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    PatentSearchGuard,
    ConfigService,
    ConfirmationService,
    ConfirmModalService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
